import { useEffect, useState } from 'react';
import api from '../../api/index.js';
import Header from '../../components/Header/Header';
import Loader from '../../components/Loader/Loader';
import s from './UpdateStatus.module.scss';
import { formatDateMsk } from '../../utils/date.js';

const UpdateStatus = () => {
  const [apis, setApis] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPercentClass = (percent) => {
    if (percent < 50) return s.red;
    if (percent < 75) return s.yellow;
    return s.green;
  };

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const res = await api.statistic.getUpdateStatus();
      if (res.apis) setApis(res.apis);
      setLoading(false);
    };
    fetch();
  }, []);

  return (
    <>
      <Header
        title="Статус обновления API"
        breadCrumbs={[
          { name: 'Главная', link: '/' },
          { name: 'Аналитика', link: '/analytics' },
          { name: 'Статус обновления', link: '/analytics/update' },
        ]}
      />
      <div className="container">
        {loading ? (
          <div className={s.loaderWrap}>
            <Loader />
          </div>
        ) : (
          <ul className={s.list}>
            {apis.map((item) => {
              const percent =
                item.total_items > 0
                  ? Math.round((item.updated_items / item.total_items) * 100)
                  : 0;
              return (
                <li key={item.api_name} className={s.card}>
                  <div className={s.cardHeader}>
                    <h3 className={s.apiName}>{item.api_name}</h3>
                    <span className={[s.badge, getPercentClass(percent)].join(' ')}>
                      {percent}%
                    </span>
                  </div>
                  <div className={s.progressWrap}>
                    <div
                      className={[s.progressBar, getPercentClass(percent)].join(' ')}
                      style={{ width: `${percent}%` }}
                    />
                  </div>
                  <div className={s.stats}>
                    <div className={s.stat}>
                      <span className={s.statLabel}>Всего товаров</span>
                      <span className={s.statValue}>{item.total_items.toLocaleString('ru-RU')}</span>
                    </div>
                    <div className={s.stat}>
                      <span className={s.statLabel}>Обновлено</span>
                      <span className={s.statValue}>{item.updated_items.toLocaleString('ru-RU')}</span>
                    </div>
                    <div className={s.stat}>
                      <span className={s.statLabel}>Последнее обновление (МСК)</span>
                      <span className={s.statValue}>
                        {formatDateMsk(item.last_updated_at)}
                      </span>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
};

export default UpdateStatus;
